import React from 'react'
import { Title, Subtitle, Subsubtitle, Body, Item, Image } from '../components/Common'

export const TodoPage = () => {
  return (
    <div className='w-full min-h-screen flex justify-center bg-stone-200 dark:bg-stone-700'>
        <div className='w-full sm:w-2/3 pt-12 sm:pt-16 pb-4 px-10 sm:px-16 bg-stone-100 dark:bg-stone-600 dark:text-white'>
            <Title>TODO LIST</Title>
            <Body> A simple space to keep my tasks in one place and help me stay on track, no matter how much time has passed. </Body>

            <Item>
                - PatchCoreViT<br/> 
                Create a Google Notebook Example for PatchCore ViT.
            </Item>

            <Item>
                - Computer Vision Project<br/>
                Create a Title and a description.  
            </Item>

            <Item>
                - Website<br/> 
                Deploy the custom DistilGPT2 on HuggingFace.<br/>
                Fill the Note Website.
            </Item>

        </div>
    </div>
  )
}
